import script from "./EpModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EpModal.vue?vue&type=script&lang=ts&setup=true"

import "./EpModal.vue?vue&type=style&index=0&id=ef82ff86&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef82ff86"]])

export default __exports__